import { PureComponent } from 'react';
import { injectIntl } from 'react-intl';

import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { createStructuredSelector } from 'reselect';

import AccountSettingsRoutes from 'routes/accountSettingsRoutes';

import { SettingsPageContainer } from 'styles/settings';

// TODO: This should be a functional component
export class AccountSettings extends PureComponent {
  render() {
    return (
      <SettingsPageContainer>
        <AccountSettingsRoutes />
      </SettingsPageContainer>
    );
  }
}

const mapStateToProps = createStructuredSelector({});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);
// @ts-expect-error TS(2345): Argument of type 'ConnectedComponent<FC<WithIntlPr... Remove this comment to see the full error message
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(injectIntl(AccountSettings)));
